<template>
  <li class="mega-menu outside d-none">
    <a
      class="nav-link"
      :class="{ active: openbonusUI }"
      href="javascript:void(0);"
      @click="openmegamenu"
    >
      <feather type="layers"></feather><span>Bonus Ui</span>
    </a>
    <div
      class="mega-menu-container nav-submenu menu-to-be-close"
      :class="{ 'd-block': openbonusUI }"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col mega-box m-b-20">
            <div class="mobile-title d-none p-10">
              <h5><Logo /></h5>
              <feather type="x" @click="closeBonusUI"></feather>
            </div>
          </div>
          <template v-for="(CompanyLink, CompanyLinkIndex) in CompanyLinks">
            <div class="col mega-box" :key="CompanyLinkIndex">
              <div class="link-section open-links">
                <div>
                  <h6>
                    <a
                      :href="
                        !CompanyLink.iframe
                          ? CompanyLink.link
                          : '/external-links/top-bar/' +
                            getTitle(CompanyLink.title)
                      "
                      :key="CompanyLinkIndex"
                      v-if="CompanyLink.title && CompanyLink.link"
                      :target="!CompanyLink.iframe ? '_blank' : '_self'"
                      :title="CompanyLink.title"
                      ><font-awesome-icon
                        :icon="'fa-solid fa-' + CompanyLink.icon.name"
                        v-if="CompanyLink.icon && CompanyLink.icon.name"
                        class="f-12"
                        style="vertical-align: middle"
                      />
                      {{ CompanyLink.title }}</a
                    >
                  </h6>
                </div>
              </div>
            </div>
          </template>
          <div class="col mega-box">
            <div class="link-section icon">
              <div :class="{ active: menuItemData == 'AddNew' }">
                <h6 @click="setNavActive('AddNew')">
                  <font-awesome-icon icon="fa-solid fa-plus-circle" /> Add New
                </h6>
              </div>
              <ul :class="{ 'childmenu open': menuItemData == 'AddNew' }">
                <li @click="closeBonusUI">
                  <router-link :to="{ path: '/vehicle-add' }">
                    <font-awesome-icon icon="fa-solid fa-car" /> Add Vehicle
                  </router-link>
                </li>

                <li @click="closeBonusUI">
                  <router-link :to="{ path: '/trailer-add' }">
                    <img
                      src="@/assets/images/trailer.png"
                      class="trailer-icon-width mr-1"
                    />
                    Add Trailer
                  </router-link>
                </li>

                <li @click="closeBonusUI">
                  <router-link :to="{ path: '/driver-add' }">
                    <font-awesome-icon icon="fa-solid fa-user-plus" /> Add
                    Driver
                  </router-link>
                </li>
                <li @click="closeBonusUI">
                  <router-link :to="{ path: '/documents' }">
                    <font-awesome-icon icon="fa-solid fa-file" /> Add Document
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col mega-box">
            <div class="link-section open-links">
              <div>
                <h6 @click="closeBonusUI">
                  <router-link to="/settings"
                    ><font-awesome-icon icon="fa-solid fa-gear" />
                    Settings</router-link
                  >
                </h6>
              </div>
            </div>
          </div>
          <div class="col mega-box">
            <div class="link-section open-links">
              <div>
                <h6>
                  <a @click="logout"
                    ><font-awesome-icon icon="fa-solid fa-sign-out" />Log out</a
                  >
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapState } from "vuex";
  import Logo from "@/components/sidebar/logo";
  import Axios from "axios";
  import firebase from "firebase";
  import UserAuth from "../../auth/js/index";
  export default {
    name: "BonusUI",
    components: {
      Logo,
    },
    data() {
      return {
        openbonusUI: false,
        menuItemData: "",
        CompanyLinks: [],
      };
    },
    computed: {
      ...mapState({
        megamenuItems: (state) => state.menu.megamenu,
      }),
    },
    mounted() {
      this.GetCompanyDetail();
    },
    methods: {
      GetCompanyDetail() {
        var CompanyData = JSON.parse(localStorage.getItem("Company"));
        if (
          CompanyData.fleet_settings_key != "" &&
          CompanyData.fleet_settings_key != null
        ) {
          var CompanySettingsKey = JSON.parse(CompanyData.fleet_settings_key);
          if (typeof CompanySettingsKey.CompanyLinks != "undefined") {
            this.CompanyLinks = CompanySettingsKey.CompanyLinks;
          }
        }
      },
      openmegamenu() {
        this.openbonusUI = !this.openbonusUI;
      },
      closeBonusUI() {
        this.openbonusUI = false;
      },
      setNavActive(item) {
        if (this.menuItemData == "") {
          this.menuItemData = item;
        } else {
          this.menuItemData = "";
        }
      },
      logout: function () {
        this.openbonusUI = false;
        firebase
          .auth()
          .signOut()
          .then(() => {
            UserAuth.Logout();
            this.$router.replace("/auth/login");
          });
      },
    },
  };
</script>
